export enum CappingType {
  NoCap = 0,
  Number = 1,
  Percentage = 2
}
